import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const RemoveEBandIpsRequest = (filePath, userName, userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}IpAssignment/RemoveEBandIps`,
	params: { filePath, userName, userId }
});
